import React, { useEffect, useRef } from 'react'

const TallyFeedbackEmbed = ({ user, itemType, slug, formID }) => {
    const iframeRef = useRef()
    const formBaseUrl = `https://tally.so/embed/${formID}`
    const params = new URLSearchParams({
        email: user.email,
        item: itemType,
        slug: slug,
        alignLeft: 1,
        transparentBackground: 1,
        dynamicHeight: 1,
    })
    const formUrl = `${formBaseUrl}?${params.toString()}`

    useEffect(() => {
        const widgetScriptSrc = 'https://tally.so/widgets/embed.js'

        const load = () => {
            if (typeof window.Tally !== 'undefined') {
                window.Tally.loadEmbeds()
                return
            }

            document
                .querySelectorAll('iframe[data-tally-src]:not([src])')
                .forEach((iframeEl) => {
                    iframeEl.src = iframeEl.dataset.tallySrc
                })
        }

        if (typeof window.Tally !== 'undefined') {
            load()
            return
        }

        if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
            const script = document.createElement('script')
            script.src = widgetScriptSrc
            script.onload = load
            script.onerror = load
            document.body.appendChild(script)
            return
        }
    }, [formUrl])

    useEffect(() => {
        if (iframeRef.current) {
            iframeRef.current.setAttribute('data-tally-src', formUrl)
            iframeRef.current.removeAttribute('src')
            if (window.Tally && typeof window.Tally.loadEmbeds === 'function') {
                window.Tally.loadEmbeds()
            }
        }
    }, [formUrl])

    return (
        <div>
            <iframe
                ref={iframeRef}
                data-tally-src={formUrl}
                loading="lazy"
                width="100%"
                height="681"
                frameBorder={0}
                marginHeight={0}
                marginWidth={0}
                title="Please share feedback on results"
                style={{ border: 'none', background: 'transparent', minHeight: 400 }}
            />
        </div>
    )
}

export default TallyFeedbackEmbed
